import styles from './CardWidthBox.module.css';
import { FCP } from '../types';

/**
 * Responsive box with fixed width of 1, 1/2 or 1/3 (of parent). Primarily meant to be used as a parent of `<Card>`, inside a flexbox.
 */
export default function CardWidthBox({ children }: FCP) {
    return <div className={styles.responsiveCardWidth}>{children}</div>;
}
